import { BookOpenCheckIcon, Building2Icon, CircleHelpIcon, GaugeIcon, LayersIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Battery Technology Professional Glossary',
    description: '200 essential battery & energy storage terms explained.',
    icon: BookOpenCheckIcon,
  },
  {
    number: '2',
    title: 'Battery Specifications Explained',
    description: 'Professional performance reference for interpreting technical data.',
    icon: GaugeIcon,
  },
  {
    number: '3',
    title: '20 Illustrative BESS Application Scenarios',
    description: 'Real-world battery storage applications across industries.',
    icon: LayersIcon,
  },
  {
    number: '4',
    title: '75 Battery & Energy Storage Misconceptions Explained',
    description: 'Common technical myths and accurate explanations.',
    icon: CircleHelpIcon,
  },
  {
    number: '5',
    title: 'Battery Storage Applications Across 12 Industries',
    description: 'Global professional guide to energy storage use cases.',
    icon: Building2Icon,
  },
];
